import getLaunchTilesDefaultBehavior from './getLaunchTilesDefaultBehavior';

import type { ViewData } from 'owa-graph-schema';

const MessageExtensionModelControl: ViewData = {
    __typename: 'ViewData',
    messageExtensionFlyoutControl: {
        __typename: 'MessageExtensionFlyoutControl',
        id: 'MessageExtensionFlyoutControl',

        // TODO: Properly localize this (bug #148579)
        flyoutEmptyStateMessage: '',
        tileBehavior: getLaunchTilesDefaultBehavior(),
    },
};

export default MessageExtensionModelControl;
